import MenuCart from '../MenuCart';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { AppointmentActionCreator, MenusActionCreator, AdditionalServicesActionCreator, WebOpsActionCreator, RMTimesActionCreator, FrameworkActionCreator, SpecsActionCreator } from 'src/store/states';
import { BlankDeptSpec } from 'src/models/Specs/TestSpecs';

const mapStateToProps = (state: IStoreState) => ({
    specData: state.Specs.specs,
    deptSpecs: state.Specs.deptSpecs,
    apptOps: state.Appointment.ApptOps,
    transFlag: state.Appointment.Appointment.transFlag,
    apptTrans: state.Appointment.Appointment.trans,
    theme: state.Framework.theme,
    store: state.Framework.store,
    branch: state.Framework.branch,
    specProfile: state.Framework.specProfile,
    webOps: state.WebOps.WebOps,
    maintMenus: state.Menus,
    noAutoRecall: state.Framework.noAutoRecall,
    skipServices: !(state.Specs.specs?.skipServicesFlag ?? false) && !(state.Specs.specs?.showWrtYourOwn ? true : false) &&
        !(state.Specs.specs?.showDiagnTool ? true : false) && state.WebOps.WebOps?.length === 0 &&
        state.Menus.allMenus.menus.length === 0,
    appointment: state.Appointment,
    apptCust: state.Appointment.ApptCust,
    apptDept: state.Appointment.Appointment.department,
    specDeptData: state.Specs.deptSpecs !== undefined ? state.Specs.deptSpecs : BlankDeptSpec,
    vehicles: state.Vehicles.vehicles,
    apptAdvNum: state.Appointment.Appointment.advisor,
    selectedVehicle: state.Vehicles.selectedVehicle,
    invalidDates: state.RMTimes.invalidDates,
    invalidDatesDept: state.RMTimes.invalidDatesDept,
    lastDeptRan: state.QuickTimes.lastDeptRan,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    deptChangeFlag: state.Appointment.deptChangeFlag ?? false,
    recom: state.AdditionalServices.allServices?.recom,
    selectedRecoms: state.AdditionalServices?.checkedRecoms,
    gmRedeemAmt: state.Appointment.Appointment.department !== 'B' ? state.Customer.Customer.gmRedeemAmt : '',
    gmDealerCanEarn: state.Appointment.Appointment.department !== 'B' ? state.Specs.specs?.gmDealerCanEarn : '',
    gmDealerCanRedeem: state.Appointment.Appointment.department !== 'B' ? state.Specs.specs?.gmDealerCanRedeem : '',
    locale: state.Framework.locale,
});

const mapDispatchToProps = {
    UpdateApptOps: AppointmentActionCreator.UpdateApptOps,
    toggleMenu: MenusActionCreator.ToggleMenu,
    toggleWeOwe: AdditionalServicesActionCreator.ToggleWeOwe,
    toggleRecommended: AdditionalServicesActionCreator.ToggleRecommended,
    toggleRecall: AdditionalServicesActionCreator.ToggleRecall,
    toggleItem: WebOpsActionCreator.ToggleItems,
    clearCheckedAdditionalServices: AdditionalServicesActionCreator.ClearCheckedAdditionalServices,
    clearCheckedWebOps: WebOpsActionCreator.ClearCheckedWebOps,
    getMenus: MenusActionCreator.GetMenus,
    getAdditionalServices: AdditionalServicesActionCreator.GetAdditionalServices,
    getApptOps: WebOpsActionCreator.GetApptOps,
    determineDept: AppointmentActionCreator.DetermineDept,
    getInvalidDates: RMTimesActionCreator.GetInvalidDates,
    clearInvalidDates: RMTimesActionCreator.ClearInvalidDates,
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    getDeptSpecs: SpecsActionCreator.GetDeptSpecs,
    getRMTimes: RMTimesActionCreator.GetRMTimes,
    clearRMTimes: RMTimesActionCreator.ClearRMTimes,
    popFromMainPane: FrameworkActionCreator.popFromMainPane,
    changeDeptFlag: AppointmentActionCreator.SetChangeDeptFlag,
    setNoAutoRecall: FrameworkActionCreator.SetNoAutoRecall,
};


export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(MenuCart);